export const ColumnsIR = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'deviceNo',
    label: '设备SN'
  },
  {
    prop: 'appName',
    label: '应用',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'advertisingTypeName',
    label: '类型',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'packageName',
    label: '包名',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'title',
    label: '标题',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'content',
    label: '内容',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'informDate',
    label: '通知时间'
  }
];

export const ColumnsWhite = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'mobile',
    label: '超管账号(手机号)',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'createDate',
    label: '添加时间',
    width: '300'
  },
  {
    label: '操作',
    slotName: 'default',
    width: '200',
    fixed: 'right'
  }
];
